import React from "react";
import MainHeadWithTitle from "@/components/mainHead";
import LeadHead from "@/app/lead/head";
import dynamic from "next/dynamic";
const LeadPage = dynamic(() => import("@/app/lead"), { ssr: false });

const Lead = () => {
  return (
    <>
      <LeadHead />
      <MainHeadWithTitle title="Inter Nation English School" />
      <LeadPage />
    </>
  );
};

export default Lead;
